import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { applyPageMetadata, metadataForPath, SITE_URL } from '../seo/metadata';
import { landingCopy } from '../locales/landing';
import { serviceCopy } from '../seo/services';

export default function Seo() {
  const { pathname } = useLocation();
  const { language } = useLanguage();
  useLayoutEffect(() => {
    document.documentElement.lang = language;
    const page = metadataForPath(pathname);
    if (language === 'kk') {
      const service = serviceCopy.kk[pathname.replace('/services/', '')];
      if (service && pathname.startsWith('/services/')) { page.title = `${service.title} — G-Launcher`; page.description = service.lead; }
      else if (pathname === '/') { page.title = landingCopy.kk.meta.title; page.description = landingCopy.kk.meta.description; }
    }
    const organization = { '@type': 'Organization', '@id': `${SITE_URL}/#organization`, name: 'G-Launcher', url: SITE_URL, logo: `${SITE_URL}/brand/icon-512.png`, email: 'support@glauncher.kz' };
    const schema: object[] = [{ '@type': 'WebPage', name: page.title, description: page.description, url: `${SITE_URL}${pathname}`, inLanguage: language === 'kk' ? 'kk-KZ' : 'ru-KZ' }];
    if (pathname === '/') schema.push(organization, { '@type': 'WebSite', '@id': `${SITE_URL}/#website`, name: 'G-Launcher', url: SITE_URL, inLanguage: language === 'kk' ? 'kk-KZ' : 'ru-KZ', publisher: { '@id': `${SITE_URL}/#organization` } });
    if (pathname.startsWith('/services/') && page.indexable) {
      schema.push(organization, { '@type': 'Service', name: page.title.replace(' — G-Launcher', ''), description: page.description, url: `${SITE_URL}${pathname}`, areaServed: { '@type': 'Country', name: 'Kazakhstan' }, provider: { '@id': `${SITE_URL}/#organization` } });
      schema.push({ '@type': 'BreadcrumbList', itemListElement: [{ '@type': 'ListItem', position: 1, name: 'G-Launcher', item: `${SITE_URL}/` }, { '@type': 'ListItem', position: 2, name: page.title.replace(' — G-Launcher', ''), item: `${SITE_URL}${pathname}` }] });
    }
    applyPageMetadata({ ...page, schema });
  }, [pathname, language]);
  return null;
}
